import {
  connect
} from 'react-redux';
import BusinessUnitsDetailIndex from '../../components/Clients/EditClientProfile/BusinessUnitsDetail';
import {
  getAccountManage,
  getClientProfile,
  getIndustryOptions,
  getTeamMember,
  getTierOptions,
  rollbackProfileStatus,
  suspendAndReactivate,
  updateClientProfile,
  getClientBusiness,
  configInsightsStandard,
  getConfigInsightsStandard,
  resetStandardConfig
} from "../../actions/Clients";
import {
  getTimezone,
  setStatus,
  getStates
} from "../../actions/Profile";

import {
  getCompanyLogo,
  updateLogo
} from "../../actions/Profile";

const mapStateToProps = (state) => {
  const {
    edit_client_profile,
    industryOptions,
    tier_options,
    ifEditClientProfileSuccess,
    teamMember_options,
    insights_standard_config,
    clientProfileUpdateError
  } = state.clients;
  const {
    company_logo,
    allstates
  } = state.myProfile;
  const { roleName, token, loginUserDetail } = state.app;
  const { timezone, ifUpdateSuccess } = state.myProfile;
  const { account_manager } = state.employees;

  return {
    edit_client_profile,
    timezone,
    industryOptions,
    tier_options,
    roleName,
    token,
    ifEditClientProfileSuccess,
    teamMember_options,
    company_logo,
    ifUpdateSuccess,
    allstates,
    loginUserDetail,
    account_manager,
    insights_standard_config,
    clientProfileUpdateError
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientProfile: (id) => {
      dispatch(getClientProfile(id))
    },
    getTimezone: () => {
      dispatch(getTimezone())
    },
    getIndustryOptions: () => {
      dispatch(getIndustryOptions())
    },
    getTierOptions: () => {
      dispatch(getTierOptions())
    },
    updateClientProfile: (id, obj) => {
      dispatch(updateClientProfile(id, obj))
    },
    rollbackProfileStatus: () => {
      dispatch(rollbackProfileStatus())
    },
    suspendAndReactivate: (clientId, status) => {
      dispatch(suspendAndReactivate(clientId, status))
    },
    getTeamMember: (id) => {
      dispatch(getTeamMember(id))
    },
    getAccountManage: () => {
      dispatch(getAccountManage())
    },
    getCompanyLogo: (id) => {
      dispatch(getCompanyLogo(id))
    },
    updateLogo: (id, uuid) => {
      dispatch(updateLogo(id, uuid))
    },
    setStatus: (value) => {
      dispatch(setStatus(value))
    },
    getClientBusiness: (id) => {
      dispatch(getClientBusiness(id))
    },
    getStates: () => {
      dispatch(getStates());
    },
    configInsightsStandard: (id, obj) => {
      dispatch(configInsightsStandard(id, obj))
    },
    getConfigInsightsStandard: (id) => {
      dispatch(getConfigInsightsStandard(id))
    },
    resetStandardConfig: () => {
      dispatch(resetStandardConfig())
    }
  }
}


const BusinessUnitsDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessUnitsDetailIndex);

export default BusinessUnitsDetail;




// WEBPACK FOOTER //
// ./src/containers/Clients/editBusinessUnitsDetail.js